/**
 * 门户工具函数
 */

// slug 路由 -> 后端数据搜索关键词
export const SLUG_KEYWORDS = {
  'single-wire': '单束多丝',
  'multi-beam': '多束并行',
  'titanium': '海绵钛',
  'lattice': '点阵结构',
  'concrete': '钢板点阵混凝土',
  'titanium-alloy': '极低成本钛合金',
  'ship': '船舶轻量化',
  'platform': '海洋浮式平台',
  'deep-sea': '深海耐压壳体'
}

/**
 * 根据名称反查 slug（首页/列表卡片跳转详情用）
 */
export function slugOf(name) {
  for (const [slug, kw] of Object.entries(SLUG_KEYWORDS)) {
    if ((name || '').includes(kw)) return slug
  }
  return ''
}

/**
 * 解析 JSON 字符串字段（features/process/specifications 等），失败返回原值
 */
export function parseJsonField(value) {
  if (!value) return []
  if (Array.isArray(value) || typeof value === 'object') return value
  try {
    return JSON.parse(value)
  } catch (e) {
    return []
  }
}
